import React from "react";
import ProductionAndSalesGenericSkeleton from "./ProductionAndSalesGenericSkeleton";

function ProductionAndSalesDetailSkeleton() {
  return (
    <>
      <ProductionAndSalesGenericSkeleton />
    </>
  );
}

export default ProductionAndSalesDetailSkeleton;
